// frontend/utils/emoji.ts

const TWEMOJI_CDN_BASE = "https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg";

/**
 * emoji-mart의 unified 코드(예: "2764-fe0f")를 실제 twemoji SVG 에셋 URL로 변환합니다.
 * twemoji 에셋 파일명은 ZWJ(200d)가 없는 단일 이모지에 붙은 변이 선택자(FE0F)는
 * 제거하지만, ZWJ 시퀀스 안의 FE0F는 그대로 유지합니다 — 이 규칙을 따르지 않고
 * unified 코드를 그대로 파일명에 쓰면 ❤️(2764-fe0f)·✏️(270f-fe0f)·☺️(263a-fe0f) 등
 * 다수의 이모지가 404로 깨집니다. 실제 CDN 응답으로 검증된 규칙입니다.
 */
export const getTwemojiSvgUrl = (code: string): string => {
  const normalized = code.includes("200d") ? code : code.replace(/-?fe0f/g, "");
  return `${TWEMOJI_CDN_BASE}/${normalized}.svg`;
};
